import ChartController, { Chart } from "./chart_controller"

export default class extends ChartController {
  static values = {
    dailyViewsLabelText: { type: String, default: "Daily Views" },
    viewsTooltipText: { type: String, default: "Views: %{count}" },
  };
  createChart(ctx) {
    this.createLineChart(ctx)
  }

  createLineChart(ctx) {
    const labels = this.extractLineChartLabels()
    const data = this.extractDataValues()

    new Chart(ctx, {
      type: "line",
      data: {
        labels: labels,
        datasets: [this.createLineDataset(data)]
      },
      options: {
        ...this.getBaseChartOptions(),
        scales: {
          y: this.createYAxisConfig(),
          x: this.createXAxisConfig()
        },
        plugins: {
          legend: this.createLineLegendConfig(),
          tooltip: this.createLineTooltipConfig()
        },
        interaction: {
          intersect: false,
          mode: "index"
        },
        layout: this.getDefaultLayout()
      }
    })
  }

  extractLineChartLabels() {
    return this.dataValue.map(item => {
      if (item.date) {
        return new Date(item.date).toLocaleDateString(document.documentElement.lang || "en", { month: "short", day: "numeric" })
      }
      return item.date
    })
  }

  createLineDataset(data) {
    return {
      label: this.dailyViewsLabelTextValue,
      data: data,
      borderColor: "rgba(37, 99, 235, 1)",
      backgroundColor: "rgba(37, 99, 235, 0.1)",
      tension: 0.4,
      fill: true,
      pointBackgroundColor: "rgba(37, 99, 235, 1)",
      pointBorderColor: "rgba(255, 255, 255, 1)",
      pointHoverBackgroundColor: "rgba(37, 99, 235, 1)",
      pointHoverBorderColor: "rgba(255, 255, 255, 1)",
      pointRadius: 4,
      pointHoverRadius: 6,
      pointBorderWidth: 2
    }
  }

  createLineLegendConfig() {
    return {
      display: true,
      position: "top",
      labels: {
        color: "rgba(107, 114, 128, 0.8)",
        font: { size: 12 },
        padding: 15,
        usePointStyle: true,
        pointStyle: "circle"
      }
    }
  }

  createLineTooltipConfig() {
    return {
      enabled: true,
      backgroundColor: "rgba(17, 24, 39, 0.9)",
      titleColor: "rgba(255, 255, 255, 1)",
      bodyColor: "rgba(255, 255, 255, 1)",
      borderColor: "rgba(37, 99, 235, 1)",
      borderWidth: 1,
      padding: 12,
      cornerRadius: 8,
      displayColors: true,
      callbacks: {
        label: (context) => this._interpolate(this.viewsTooltipTextValue, { count: context.parsed.y })
      }
    }
  }
}
